import React from "react";
import Tag from "../../../../ui-components/molecules/tag/tag";
import { cn } from "../../../../services/common/className";
import { AccessorialApprovalStatus } from "../../../../app/data/shipment-reconciliation/models";
import moment from "moment";
import { ReactComponent as PenUnderline } from "../../../../images/pen_underline.svg";
import XGSIcon from "../../../../ui-components/icon/xgsIcon";
import XGSIcons from "../../../../ui-components/icon/xgsIcons";
import Legend from "../../../../ui-components/molecules/legend/legend";

const getFormattedCapatlizedString = (rawString: string) => {
  if (!rawString) return rawString;
  return rawString.split(/[ ,|_]+/).map(ele => `${ele.slice(0, 1).toUpperCase()}${ele.slice(1).toLocaleLowerCase()}`).join(" ");
}

export const getBillingReviewAccessorialsColumns = (onAccessorialApproval: any, terminalAirportCode: string, terminalName: string, terminalNumber: number) => [
  {
    header: "Name",
    id: "accessorialDefinition.name",
    size: 100,
    cell: (cellProps: any) => (
      <>
        {getFormattedCapatlizedString(cellProps.row.original.accessorialDefinition.name)}
      </>
    )
  },
  {
    header: "Reason",
    id: "applicationReason",
    size: 180,
    cell: (cellProps: any) => (
      <>
        {cellProps.row.original.applicationReason}
      </>
    )
  },
  {
    header: "Added",
    id: "createdAt",
    size: 150,
    cell: (cellProps: any) => (
      <div className="cell__creation-details">
        <div className="created-at">
          At: {moment(cellProps.row.original.createdAt).format("MM/DD/YY HH:mm")}
        </div>
        <div className="created-by">
          By: {cellProps.row.original.createdBy}
        </div>
      </div>
    )
  },
  {
    header: "Operations Approval",
    id: "operationNotes",
    size: 150,
    cell: (cellProps: any) => (
      <div className="cell__operations-approval">
        <div className="notes">
          {cellProps.row.original.operationNotes}
        </div>
        <div className="created-at">
          At: {moment(cellProps.row.original.operationApprovedAt).format("MM/DD/YY HH:mm")}
        </div>
        <div className="created-by">
          By: {cellProps.row.original.operationApprovedBy}
        </div>
        <div className="terminal">
          {terminalAirportCode} - {getFormattedCapatlizedString(terminalName)} <span className="terminal--text-light">{terminalNumber}</span>
        </div>
      </div>
    )
  },
  {
    header: "Actions",
    id: "billingApprovalStatus",
    size: 180,
    cell: (cellProps: any) => (
      <div className="cell__approval-status">
        {(cellProps.row.original.billingApprovalStatus === AccessorialApprovalStatus.PENDING)
          ? <div className="approval">
            <span
              onClick={(e) => {
                e.stopPropagation();
                onAccessorialApproval(AccessorialApprovalStatus.ACCEPTED, cellProps.row.original);
              }}
            >
              <span className="approval__action approval__approve"><XGSIcon icon={XGSIcons.faCheckCircle}></XGSIcon></span>
            </span>
            <span
              onClick={(e) => {
                e.stopPropagation();
                onAccessorialApproval(AccessorialApprovalStatus.RJECTED, cellProps.row.original);
              }}
            >
              <span className="approval__action approval__reject"><XGSIcon icon={XGSIcons.faTimesCircle}></XGSIcon></span>
            </span>
          </div>
          : <div className="approval">
            <div className="approval-status">
              <Tag
                mix={(cellProps.row.original.billingApprovalStatus === AccessorialApprovalStatus.ACCEPTED) ? cn("approval")("approve") : cn("approval")("reject")}
              >{(cellProps.row.original.billingApprovalStatus === AccessorialApprovalStatus.ACCEPTED) ? "Approved" : "Rejected"}
                <Legend><>
                  <div className="created-at">
                    At: {(cellProps.row.original.billingApprovedAt) ? moment(cellProps.row.original.billingApprovedAt).format("MM/DD/YY HH:mm") : ""}
                  </div>
                  <div className="created-by">
                    By: {cellProps.row.original.billingApprovedBy}
                  </div>
                </></Legend>
              </Tag>
              <div
                className="approval-status__edit-action"
                onClick={(e) => {
                  e.stopPropagation();
                  onAccessorialApproval(
                    (cellProps.row.original.billingApprovalStatus === AccessorialApprovalStatus.ACCEPTED) ? AccessorialApprovalStatus.RJECTED : AccessorialApprovalStatus.ACCEPTED,
                    cellProps.row.original
                  );
                }}
              ><PenUnderline />
                <span className="actions--title">Edit</span></div>
            </div>
          </div>
        }
      </div>
    )
  },
  {
    header: "Approval Notes",
    id: "billingNotes",
    size: 150,
    cell: (cellProps: any) => (
      <>{cellProps.row.original.billingNotes}</>
    )
  },
];
